import React, { useState, useEffect } from "react";
import {
  Card,
  Table,
  Badge,
  Spinner,
  Alert,
  Form,
  InputGroup,
  Row,
  Col,
  Button,
} from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import { API_URL } from "../../services/api";
import axios from "axios";
import "./Dashboard.css";
const PAGE_SIZE = 20;

const SIHALAL_HOST =
  process.env.REACT_APP_SIHALAL_HOSTNAME || "lembaga.halal.go.id";

const fileUrl = (filename) =>
  filename ? `https://${SIHALAL_HOST}/files/${filename}` : null;

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  try {
    return new Date(dateStr).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  } catch {
    return dateStr;
  }
};

const StatusBadge = ({ status }) => {
  if (!status) return <Badge bg="secondary">-</Badge>;
  const s = status.toLowerCase();
  if (s === "terbayar") return <Badge bg="success">{status}</Badge>;
  if (s === "disetujui")
    return (
      <Badge bg="warning" text="dark">
        {status}
      </Badge>
    );
  if (s === "pengajuan") return <Badge bg="info">{status}</Badge>;
  if (s.includes("batal")) return <Badge bg="danger">{status}</Badge>;
  return <Badge bg="secondary">{status}</Badge>;
};

const DaftarTagihan = () => {
  const navigate = useNavigate();
  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Filters
  const today = new Date();
  const defaultDari = `${today.getFullYear()}-01-01`;
  const defaultSampai = today.toISOString().slice(0, 10);
  const [tglDari, setTglDari] = useState(defaultDari);
  const [tglSampai, setTglSampai] = useState(defaultSampai);
  const [statusFilter, setStatusFilter] = useState("semua");
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        const res = await axios.get(`${API_URL}/tagihan/daftar`);
        if (res.data.success) {
          setAllData(res.data.data || []);
        } else {
          setError("Gagal memuat data tagihan");
        }
      } catch (err) {
        setError(
          "Gagal memuat data: " + (err.response?.data?.message || err.message),
        );
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  // Apply filters
  const filtered = allData.filter((row) => {
    // Date range filter on tanggal
    if (tglDari && row.tanggal) {
      if (new Date(row.tanggal) < new Date(tglDari)) return false;
    }
    if (tglSampai && row.tanggal) {
      const end = new Date(tglSampai);
      end.setHours(23, 59, 59, 999);
      if (new Date(row.tanggal) > end) return false;
    }
    // Status filter
    if (statusFilter !== "semua") {
      const rowStatus = (row.status_payment || "").toLowerCase();
      if (rowStatus !== statusFilter) return false;
    }
    // Search by nomor
    if (search) {
      const q = search.toLowerCase();
      if (
        !(row.nomor || "").toLowerCase().includes(q) &&
        !(row.file_invoice || "").toLowerCase().includes(q)
      )
        return false;
    }
    return true;
  });

  // Pagination
  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const paginated = filtered.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE,
  );

  const handleFilterChange = (setter) => (e) => {
    setter(e.target.value);
    setCurrentPage(1);
  };

  // Stats summary
  const totalTerbayar = allData.filter(
    (r) => (r.status_payment || "").toLowerCase() === "terbayar",
  ).length;
  const totalDisetujui = allData.filter(
    (r) => (r.status_payment || "").toLowerCase() === "disetujui",
  ).length;
  const totalPengajuan = allData.filter(
    (r) => (r.status_payment || "").toLowerCase() === "pengajuan",
  ).length;

  return (
    <div>
      {/* Page header */}
      <div
        className="page-header-banner"
        style={{
          background:
            "linear-gradient(135deg, var(--primary-color) 0%, var(--primary-hover) 50%, var(--primary-dark) 100%)",
        }}
      >
        <div className="page-header-content">
          <div className="page-header-left">
            <div className="page-header-icon">
              <i className="fas fa-receipt"></i>
            </div>
            <div>
              <h1 className="page-header-title">Daftar Tagihan</h1>
              <p className="page-header-subtitle">
                Monitoring invoice dan status pembayaran LP3H
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Summary cards */}
      {!loading && !error && allData.length > 0 && (
        <Row className="mb-3 g-3">
          <Col xs={12} sm={3}>
            <Card className="text-center border-0 shadow-sm">
              <Card.Body>
                <div
                  style={{
                    fontSize: 28,
                    fontWeight: 700,
                    color: "var(--primary-color)",
                  }}
                >
                  {allData.length}
                </div>
                <div className="text-muted small">Total Invoice</div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={3}>
            <Card className="text-center border-0 shadow-sm">
              <Card.Body>
                <div
                  style={{ fontSize: 28, fontWeight: 700, color: "#0dcaf0" }}
                >
                  {totalPengajuan}
                </div>
                <div className="text-muted small">Pengajuan</div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={3}>
            <Card className="text-center border-0 shadow-sm">
              <Card.Body>
                <div
                  style={{ fontSize: 28, fontWeight: 700, color: "#fd7e14" }}
                >
                  {totalDisetujui}
                </div>
                <div className="text-muted small">Disetujui</div>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} sm={3}>
            <Card className="text-center border-0 shadow-sm">
              <Card.Body>
                <div
                  style={{ fontSize: 28, fontWeight: 700, color: "#198754" }}
                >
                  {totalTerbayar}
                </div>
                <div className="text-muted small">Terbayar</div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      <Card>
        <Card.Body>
          {/* Filters */}
          <Row className="mb-3 g-2 align-items-end">
            <Col xs={12} sm={6} md={3}>
              <Form.Label className="small fw-semibold mb-1">
                Dari Tanggal
              </Form.Label>
              <Form.Control
                type="date"
                size="sm"
                value={tglDari}
                onChange={handleFilterChange(setTglDari)}
              />
            </Col>
            <Col xs={12} sm={6} md={3}>
              <Form.Label className="small fw-semibold mb-1">
                Sampai Tanggal
              </Form.Label>
              <Form.Control
                type="date"
                size="sm"
                value={tglSampai}
                onChange={handleFilterChange(setTglSampai)}
              />
            </Col>
            <Col xs={12} sm={6} md={2}>
              <Form.Label className="small fw-semibold mb-1">Status</Form.Label>
              <Form.Select
                size="sm"
                value={statusFilter}
                onChange={handleFilterChange(setStatusFilter)}
              >
                <option value="semua">Semua Status</option>
                <option value="pengajuan">Pengajuan</option>
                <option value="disetujui">Disetujui</option>
                <option value="terbayar">Terbayar</option>
              </Form.Select>
            </Col>
            <Col xs={12} sm={6} md={4}>
              <Form.Label className="small fw-semibold mb-1">
                Cari Nomor Invoice
              </Form.Label>
              <InputGroup size="sm">
                <InputGroup.Text>
                  <i className="fas fa-search"></i>
                </InputGroup.Text>
                <Form.Control
                  placeholder="Ketik nomor invoice..."
                  value={search}
                  onChange={handleFilterChange(setSearch)}
                />
                {search && (
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    onClick={() => {
                      setSearch("");
                      setCurrentPage(1);
                    }}
                  >
                    <i className="fas fa-times"></i>
                  </Button>
                )}
              </InputGroup>
            </Col>
          </Row>

          {loading && (
            <div className="text-center py-5">
              <Spinner animation="border" variant="primary" />
              <p className="mt-2 text-muted">Memuat data tagihan...</p>
            </div>
          )}

          {error && (
            <Alert variant="danger">
              <i className="fas fa-exclamation-circle me-2"></i>
              {error}
            </Alert>
          )}

          {!loading && !error && filtered.length === 0 && (
            <div className="text-center py-5">
              <i className="fas fa-inbox fa-3x text-muted mb-3"></i>
              <p className="text-muted">
                Tidak ada data tagihan yang sesuai filter.
              </p>
            </div>
          )}

          {!loading && !error && filtered.length > 0 && (
            <>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <small className="text-muted">
                  Menampilkan {(currentPage - 1) * PAGE_SIZE + 1}–
                  {Math.min(currentPage * PAGE_SIZE, filtered.length)} dari{" "}
                  {filtered.length} data
                </small>
              </div>
              <div className="table-responsive">
                <Table hover size="sm" className="align-middle">
                  <thead className="table-light">
                    <tr>
                      <th style={{ width: 50 }}>No</th>
                      <th>Nomor Invoice</th>
                      <th>Tanggal</th>
                      <th>Status Bayar</th>
                      <th style={{ width: 80 }}>Detil</th>
                    </tr>
                  </thead>
                  <tbody>
                    {paginated.map((row, idx) => (
                      <tr key={row.id}>
                        <td className="text-muted">
                          {(currentPage - 1) * PAGE_SIZE + idx + 1}
                        </td>
                        <td>
                          <span className="fw-semibold">
                            {row.nomor || "-"}
                          </span>
                        </td>
                        <td>{formatDate(row.tanggal)}</td>
                        <td>
                          <StatusBadge status={row.status_payment} />
                        </td>
                        <td>
                          <button
                            className="btn btn-outline-info btn-sm"
                            onClick={() => {
                              const token = Math.random()
                                .toString(36)
                                .slice(2, 13);
                              localStorage.setItem(
                                `_tinv_${token}`,
                                JSON.stringify({
                                  id: row.id,
                                  nomor: row.nomor,
                                  tanggal: row.tanggal,
                                  status_payment: row.status_payment,
                                  tgl_transfer: row.tgl_transfer,
                                }),
                              );
                              navigate(`/admin/tagihan/detail/${token}`);
                            }}
                          >
                            <i className="fas fa-eye me-1"></i>
                            Detil
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="d-flex justify-content-center gap-1 mt-3 flex-wrap">
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    disabled={currentPage === 1}
                    onClick={() => setCurrentPage(currentPage - 1)}
                  >
                    &laquo;
                  </Button>
                  {Array.from({ length: totalPages }, (_, i) => i + 1)
                    .filter(
                      (p) =>
                        p === 1 ||
                        p === totalPages ||
                        Math.abs(p - currentPage) <= 2,
                    )
                    .reduce((acc, p, i, arr) => {
                      if (i > 0 && p - arr[i - 1] > 1) acc.push("...");
                      acc.push(p);
                      return acc;
                    }, [])
                    .map((p, i) =>
                      p === "..." ? (
                        <Button
                          key={`ellipsis-${i}`}
                          variant="outline-secondary"
                          size="sm"
                          disabled
                        >
                          …
                        </Button>
                      ) : (
                        <Button
                          key={p}
                          variant={
                            p === currentPage ? "primary" : "outline-secondary"
                          }
                          size="sm"
                          onClick={() => setCurrentPage(p)}
                        >
                          {p}
                        </Button>
                      ),
                    )}
                  <Button
                    variant="outline-secondary"
                    size="sm"
                    disabled={currentPage === totalPages}
                    onClick={() => setCurrentPage(currentPage + 1)}
                  >
                    &raquo;
                  </Button>
                </div>
              )}
            </>
          )}
        </Card.Body>
      </Card>
    </div>
  );
};

export default DaftarTagihan;
